import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useColorStore } from "../stores/ColorStore"
import { useCounterStore } from "../stores/CounterStore"
import ImageEditor from "./ImageEditor"
import OptionsRow from "./OptionsRow"
import { useCamTargetStore } from "../stores/CamTargetStore"
import ColorsRow from "./ColorsRow"

export default function Interface(props) {
    const bodyColor = useColorStore((state) => state.body)
    const capColor = useColorStore((state) => state.cap)
    const assignBodyColor = useColorStore((state) => state.assignBody)
    const assignCapColor = useColorStore((state) => state.assignCap)

    const camPositionId = useCounterStore((state) => state.camTransformId)
    const assignCamId = useCounterStore((state) => state.assign)

    const camTargetPos = useCamTargetStore((state) => state.camTargetPosition)
    const setTargetPos = useCamTargetStore((state) => state.setTargetPosition)

    // const [language, setLanguage] = useState("EN")
    const language = props.language

    const [capacity, setCapacity] = useState("")
    const [customizationType, setCustomizationType] = useState("")
    const [numOfColors, setNumOfColors] = useState("")

    useEffect(() => {
        // TODO - Refactor
        if(capacity && capacity != "") {
            let capacities = props.model.data.capacity.split(",") 
            // Update model on capacity user change
            if(capacities.length > 1) {
                Object.keys(capacities).forEach((index) => {
                    if(capacities[index].startsWith(capacity[0])) {  // Finds capacity option that starts with new capacity's first character
                        let newModel = props.models.find(_model => 
                            _model.id.startsWith(props.model.id.split("_")[0] + "_" + capacity[0])
                        )
                        let newSpots = props.spots.map((_spot, i) => {
                            return (_spot.model_id == props.model.id) ? {..._spot, model_id: newModel?.id} : _spot;
                        })
                        props.setSpots(newSpots)
                        props.setCurrentModel(newModel)
                        let newBodyColor = newModel.data.bodyColors ? newModel.data.bodyColors.split(",")[0] : "white"
                        let newCapColor = newModel.data.capColors ? newModel.data.capColors.split(",")[0] : "white"
                        assignBodyColor(newBodyColor)
                        assignCapColor(newCapColor)
                    }
                })
            }
        }
    }, [capacity])

    // const optionsRef = useRef()
    // const [optionsIndex, setOptionsIndex] = useState([])
    const [currentOptionIndex, setCurrentOptionIndex] = useState(1)
    // useEffect(() => console.log(currentOptionIndex), [currentOptionIndex])

    // useLayoutEffect(() => {
    //     if(!optionsRef.current) return;
    //     // console.log(optionsDiv.current);
    //     for(let i = 0; i < optionsRef.current.childNodes.length; i++) {
    //         if(optionsRef.current.childNodes[i].nodeName != "DIV") break;
    //         optionsRef.current.childNodes[i].id = i
    //     }
    // }, [props.model])

    const customizationPanel = useRef()
    useEffect(() => {
        if(camPositionId == 5) {
            customizationPanel.current.classList.remove("outside-screen-right")
        }
    }, [camPositionId])

    const [isImageEditorVisible, setImageEditorVisibility] = useState(false)
    useEffect(() => {
        if(!customizationPanel.current) return
        setTargetPos([camTargetPos[0], camTargetPos[1], camTargetPos[2] + ((isImageEditorVisible) ? -.14 : .14)])
        if(isImageEditorVisible)
            customizationPanel.current.classList.add("customization-panel-closeup")
        else 
            customizationPanel.current.classList.remove("customization-panel-closeup")
    }, [isImageEditorVisible])

    // Update options state on model data change
    useEffect(() => {
        setCapacity(props.model?.data.capacity?.split(',')[0])
        setCustomizationType(props.model?.data.customizationType?.split(',')[0])
        setNumOfColors(props.model?.data.numOfColors?.split(',')[0])
    }, [props.model])

    const goToShopLegacy = () => {
        let shopURL = "https://www.thebrandcompany.net/en_GB/shop/tbc160-custom-carton-water-558"
        let bodyColorText = (bodyColor == "#000000" ? "6" : "5")
        let capColorText = ""
        switch (capColor) {
            case "#ffffff":
                capColorText = "57"
                break;
            case "#0000FF":
                capColorText = "59"
                break;
            case "#FF0000":
                capColorText = "60"
                break;
            case "#000000":
                capColorText = "58"
                break;
            default:
                capColorText = "57"
                break;
        }

        shopURL += "#attr=5561,555" + bodyColorText + ",55" + capColorText + ",5550,5552,7180,7191"
        window.open(shopURL)
    }
    const goToShop = () => {
        window.open(props.model.url)
    }

    // const getElementId = (_optionTitle) => {
    //     if(optionsRef.current == null) return;
    //     let _id = -1;
    //     // console.log(optionsRef.current);
    //     optionsRef.current.childNodes.forEach((c, i) => {
    //         if(c.firstChild.innerText && c.firstChild.innerText == _optionTitle) {
    //             // console.log(_optionTitle + " " + i);
    //             _id = i
    //         }
    //     })
    //     return _id;
    // }

    const getCustomizationPanelContents = () => {
        if(props.model.id == "") return;
        let panelContents = []
        let _id = 0

        // console.log(props.model);
        if(props.model.data.capacity != undefined && props.model.data.capacity.split(',')[0] != "") {
            panelContents.push(<OptionsRow 
                optionsTitle={"Capacity"} 
                rawOptions={props.model.data.capacity} 
                option={capacity}
                setOption={setCapacity}
                setOptionIndex={setCurrentOptionIndex}
                elementId={_id}
                currentIndex={currentOptionIndex}
            />)
            _id++;
        }
        if(props.model.data.bodyColors != undefined && props.model.data.bodyColors.split(',')[0] != "") {
            panelContents.push(<ColorsRow 
                colorsTitle={"Product Color"} // TODO - Change to multilanguage
                rawColors={props.model.data.bodyColors} 
                setColor={assignBodyColor}
                setOptionIndex={setCurrentOptionIndex}
                elementId={_id}
                currentIndex={currentOptionIndex}
            />)
            _id++;
        }
        if(props.model.data.capColors != undefined && props.model.data.capColors.split(',')[0] != "") {
            panelContents.push(<ColorsRow 
                colorsTitle={"Color of Cap or Lid"} // TODO - Change to multilanguage
                rawColors={props.model.data.capColors} 
                setColor={assignCapColor}
                setOptionIndex={setCurrentOptionIndex}
                elementId={_id}
                currentIndex={currentOptionIndex}
            />)
            _id++;
        }
        if(props.model.data.customizationType != undefined && props.model.data.customizationType.split(',')[0] != "") {
            panelContents.push(<OptionsRow 
                optionsTitle={"Type of Customization"} 
                rawOptions={props.model.data.customizationType} 
                option={customizationType}
                setOption={setCustomizationType}
                setOptionIndex={(newId) => setCurrentOptionIndex(newId)}
                elementId={_id}
                currentIndex={currentOptionIndex}
            />)
            _id++;
        }
        if(props.model.data.numOfColors != undefined && props.model.data.numOfColors.split(',')[0] != "") {
            panelContents.push(<OptionsRow 
                optionsTitle={"Number of Customization Colors"} 
                rawOptions={props.model.data.numOfColors}
                option={numOfColors}
                setOption={setNumOfColors}
                setOptionIndex={(newId) => setCurrentOptionIndex(newId)}
                elementId={_id}
                currentIndex={currentOptionIndex}
            />)
            _id++;
        }
        return panelContents
    }

    return <>
        {camPositionId == 8
            ? <div style={{ position: "absolute", bottom: "12px", width: "100%", textAlign: "center" }}>
                <p><i>Projecte impulsat amb el Programa eTrade d'
                    <a href="https://www.accio.gencat.cat/etrade" style={{ color: "black" }}>ACCIÓ</a>
                </i></p>
            </div>
            : <></>
        }

        {/* {camPositionId == 0 || camPositionId == 7 || camPositionId == 2 ||  */}
        { true
            ? <div className="languages-background" style={{ textAlign: "center", fontFamily: "sans-serif" }}>
                {["EN", "ES", "FR", "IT", "DE"].map((langId, i) => {
                    return <>
                        <a onClick={() => props.setLang(langId)} key={i} 
                           style={{ margin: "8px", fontSize: "24px", fontWeight: langId == language ? "bold" : "normal", cursor: "pointer" }}
                        >
                            {langId}
                        </a>
                    </>
                })}
            </div>
            : <></>
        }

        {camPositionId != 0
            ? <button // BACK BUTTON. TODO - Proper back system
                onClick={() => {
                    assignCamId(camPositionId != 5 ? 0 : 2)
                    setImageEditorVisibility(false)
                    setCurrentOptionIndex(1)
                }}
                className="round-button"
                style={{ position: "absolute", top: "3%", left: "1.5%" }}
            > BACK
            </button>
            : <></>
        }
        
        {/* TODO - Proper check for item close up */}
        {camPositionId == 5 ? <>
            <div ref={customizationPanel} className="customization-panel outside-screen-right">
                <div style={{ display: "grid", justifyItems: "center" /*overflowY: "scroll"*/ }}>
                    <h1>{props.model.data[language].title}</h1>
                    <h2>{props.model.data[language].subtitle}</h2>
                    
                    <div /*ref={optionsRef}*/ style={{ width: "32rem" }}>
                        {!isImageEditorVisible ? <>
                            {getCustomizationPanelContents()?.map((row) => row)}
                            <>
                            {/* <OptionsRow 
                                optionsTitle={"Capacity"} 
                                rawOptions={props.model.data.capacity} 
                                option={capacity}
                                setOption={setCapacity}
                                setOptionIndex={setCurrentOptionIndex}
                                getElementId={getElementId}
                                currentIndex={currentOptionIndex}
                            />
                            
                            {props.model.data.bodyColors?.split(",").length >= 1 && props.model.data.bodyColors?.split(",")[0] != ""
                                               // VVVVV - update to custom event, breaks with multilanguage
                                ? <div className={getElementId("Product Color") < currentOptionIndex ? "" : "disabled-options-block"}>
                                    <h3>Product Color</h3> 
                                    <div style={{ display: "flex" }}>
                                        {props.model.data.bodyColors.split(",").map((color, i) => {
                                            return <div className="color-option" style={{ backgroundColor: color }} key={i}
                                                onClick={() => {
                                                    assignBodyColor(color)
                                                    // console.log(color)
                                                    setCurrentOptionIndex(getElementId("Product Color")+2)
                                                }}>
                                            </div>
                                        })}
                                    </div>
                                </div>
                                : <></>
                            }

                            {props.model.data.capColors?.split(",").length >= 1 && props.model.data.capColors?.split(",")[0] != ""
                                ? <div className={getElementId("Colour of Cap or Lid") < currentOptionIndex ? "" : "disabled-options-block"}>
                                    <h3>Colour of Cap or Lid</h3>
                                    <div style={{ display: "flex" }}>
                                        {props.model.data.capColors.split(",")?.map((color, i) => {
                                            return <div className="color-option" style={{ backgroundColor: color }} key={i}
                                                onClick={() => {
                                                    assignCapColor(color)
                                                    // console.log(color)
                                                    setCurrentOptionIndex(getElementId("Colour of Cap or Lid")+2)
                                                }}>
                                            </div>
                                        })}
                                    </div>
                                </div>
                                : <></>
                            }

                            <OptionsRow 
                                optionsTitle={"Type of Customization"} 
                                rawOptions={props.model.data.customizationType} 
                                option={customizationType}
                                setOption={setCustomizationType}
                                setOptionIndex={(newId) => setCurrentOptionIndex(newId)}
                                getElementId={getElementId}
                                currentIndex={currentOptionIndex}
                            />
                            
                            <OptionsRow 
                                className={getElementId("Number of Customization Colors") < currentOptionIndex ? "" : "disabled-options-block"}
                                optionsTitle={"Number of Customization Colors"} 
                                rawOptions={props.model.data.numOfColors} 
                                option={numOfColors}
                                setOption={setNumOfColors}
                                setOptionIndex={(newId) => setCurrentOptionIndex(newId)}
                                getElementId={getElementId}
                                currentIndex={currentOptionIndex}
                            /> */}
                            </>
                        </> : <></>}

                        <ImageEditor 
                            isVisible={isImageEditorVisible} 
                            setVisibility={() => setImageEditorVisibility(!isImageEditorVisible)}
                            templateUrl={props.model.template_url}
                        /> 
                        
                        {!isImageEditorVisible ? 
                        <div style={{ display: "flex", alignContent: "flex-end", justifyContent: "space-between", paddingBottom: "2em"}}>
                            <div>
                                <img style={{ position: "absolute", top: ".5rem", left: "-4.5rem", width: "4rem", opacity: ".5", cursor: "pointer"}} src="/photo-camera.png"
                                    onClick={() => {
                                        let a = document.createElement("a")
                                        a.href = props.canvas.current.toDataURL()
                                        a.download = props.model.id
                                        a.dispatchEvent(new MouseEvent("click"))
                                        a.remove()
                                    }}
                                />
                                {/* <img style={{ height: "3rem", margin: ".5rem" }} src="/templates.png" 
                                    onClick={() => window.open(props.model.template_url)}
                                /> */}
                            </div>
                            <div>
                                
                            </div>
                            {/* <button style={{marginTop: "2.5rem", marginLeft: "0"}} className="round-button" onClick={() => setImageEditorVisibility(!isImageEditorVisible)}> 
                                LABEL EDITOR
                            </button> */}
                            <button className="round-button"
                                onClick={goToShop}
                                style={{ margin: "10px", marginRight: "0", marginTop: "2.5rem" }}>
                                GO TO SHOP
                            </button>
                        </div>
                        : <></>}
                    </div>
                </div>
            </div></>
            : <></>}
    </>
}